import { IIncentive } from '../../types/incentive';
import { changeToZeroMoment } from '../timeHelpers';
import { numberWithCommas } from '../format';

export const groupDataToCsv = (data: IIncentive[]): string[][] => {
    const groupData: string[][] = [
        ['Received Bonus ID', 'Provider', 'Employee ID', 'Received Date', 'Total', 'Period Start', 'Period End'],
    ];

    data.forEach((it) => {
        const incentiveDate = it.incentiveDate ? changeToZeroMoment(it.incentiveDate, 'MMM D, YYYY') : '';
        const total: string = it?.total ? `$${numberWithCommas(it.total)}` : '0';
        const id: string = it?.id ? `${it.id}` : '0';
        const provider: string = it?.provider?.fullName ? `${it?.provider?.fullName}` : '';
        const employeeId: string = it?.provider?.employeeId ? `${it?.provider?.employeeId}` : '';
        const periodStart = it['periodStart'] ? changeToZeroMoment(it['periodStart'], 'MMM D, YYYY') : '';
        const endPeriod = it['periodEnd'] ? changeToZeroMoment(it['periodEnd'], 'MMM D, YYYY') : '';
        groupData.push([id, provider, employeeId, incentiveDate, total, periodStart, endPeriod]);
    });

    return groupData;
};
